import React from 'react';

import type { ShipmentExim } from '@/services/api/shipments';

// EXIM direction tag for a 4W shipment. Mirrors ShipmentStatusBadge's shape so
// the two sit side by side in the table and the detail header. Umum/GENERAL
// is the non-EXIM default and deliberately renders nothing — only a genuine
// Export or Import earns a tag.
const EXIM_CONFIG: Record<
  Exclude<ShipmentExim, 'GENERAL'>,
  { label: string; bg: string; text: string }
> = {
  EXPORT: {
    label: 'Export',
    bg: 'bg-feature-lighter',
    text: 'text-feature-dark',
  },
  IMPORT: {
    label: 'Import',
    bg: 'bg-information-lighter',
    text: 'text-information-dark',
  },
};

/** Human label for a direction (used by the filter + export picker too). */
export const getShipmentEximLabel = (exim: ShipmentExim): string =>
  exim === 'GENERAL' ? 'Umum' : EXIM_CONFIG[exim].label;

interface ShipmentEximBadgeProps {
  exim?: ShipmentExim | string | null;
  className?: string;
}

export const ShipmentEximBadge: React.FC<ShipmentEximBadgeProps> = ({
  exim,
  className = '',
}) => {
  if (exim !== 'EXPORT' && exim !== 'IMPORT') return null;
  const config = EXIM_CONFIG[exim];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${config.bg} ${config.text} ${className}`.trim()}
    >
      <i className="ri-ship-line text-[12px]" />
      {config.label}
    </span>
  );
};

export default ShipmentEximBadge;
